import React, { useEffect, useState } from 'react';
import { openBlankCoachTab, openCoachMode } from './deviceStore';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://referee-roster-api-v2-hqghffesdfegd2dq.australiaeast-01.azurewebsites.net/api';

function formatTime(value) {
  if (!value) return '';
  const [h, m] = value.split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')}${h >= 12 ? 'pm' : 'am'}`;
}

// Swish IQ trial days for the Coach Planner's selected date. Staff see the
// sessions they can access and can open coach mode (new tab).
export default function PlannerTrialStrip({ date }) {
  const [days, setDays] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setError('');
    fetch(`${API_BASE}/swishiq/schedule?startDate=${date}&endDate=${date}`)
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => { if (!cancelled) setDays(Array.isArray(rows) ? rows : []); })
      .catch(() => { if (!cancelled) setDays([]); });
    return () => { cancelled = true; };
  }, [date]);

  if (!days.length) return null;

  async function launch(day) {
    const tab = openBlankCoachTab();
    setBusyId(day.subEventId);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/swishiq/unlock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subEventId: day.subEventId })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `Couldn't open coach mode (HTTP ${res.status})`);
      openCoachMode(data, tab);
      setBusyId(null);
    } catch (e) {
      if (tab) tab.close();
      setError(e.message);
      setBusyId(null);
    }
  }

  return (
    <div style={{ margin: '0 0 1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {error && <div className="error-message">{error}</div>}
      {days.map((day) => (
        <div key={day.subEventId} style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', alignItems: 'center', justifyContent: 'space-between', border: '2px solid #a4161a', background: '#fff8f8', borderRadius: 10, padding: '0.6rem 0.9rem' }}>
          <div>
            <strong>{day.eventName}</strong>{' '}
            <span style={{ background: '#ff66c4', color: '#fff', borderRadius: 4, fontSize: '0.65rem', fontWeight: 800, padding: '1px 6px', verticalAlign: 'middle' }}>SWISHIQ TRIALS</span>
            <div style={{ fontSize: '0.85rem', color: '#555' }}>
              {formatTime(day.startTime)}–{formatTime(day.endTime)} · Day {day.dayNumber} of {day.dayCount} · {day.type} · {day.playerCount} players
              {day.headCoachName ? ` · Head coach ${day.headCoachName}` : ''}
            </div>
          </div>
          <button
            type="button"
            onClick={() => launch(day)}
            disabled={busyId === day.subEventId}
            style={{ background: '#a4161a', color: '#fff', border: 'none', borderRadius: 999, padding: '0.45rem 1rem', fontWeight: 700, cursor: 'pointer' }}
          >
            {busyId === day.subEventId ? 'Opening…' : 'Open coach mode'}
          </button>
        </div>
      ))}
    </div>
  );
}
